import React, { useState, useEffect } from "react";

import { useNavigate, useLocation } from "react-router-dom";
import { role_list } from "../redux/api/dummyJson";
import { toggle_off, toggle_on } from "../../assets/imgs";
import apiRequest from "../redux/api/apiRequest";
import {
  useLazyPermissionsListQuery,
  useAddRoleMutation,
  useLazyViewRoleQuery,
  useUpdateRoleMutation,
} from "../redux/api/api";
import { toast } from "react-toastify";

const CompanyRoleAdd = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [name, setName] = useState("");
  const [roleList, setRoleList] = useState([]);
  const [permissions, setPermissions] = useState([]);
  const [selectedPermissions, setSelectedPermissions] = useState([]);
  const [selectedPermission_, setSelectedPermission_] = useState([]);
  const permissionArr = ["add", "edit", "view", "status", "delete"];
  const [loader, setLoader] = useState(false);
  const [error, setError] = useState(false);
  const [seperation, setSepertion] = useState();

  const [permissionsList] = useLazyPermissionsListQuery();
  const [viewRole] = useLazyViewRoleQuery();
  const [addRole] = useAddRoleMutation();
  const [updateRole] = useUpdateRoleMutation();
  const type = location?.state?.type;
  const id = location?.state?.id;

  const getPermissionsList = async () => {
    const res = await apiRequest(permissionsList);
    if (res?.status == "success") {
      let filert_ = res?.modules?.filter((i) => i?.type == 2);
      setRoleList(filert_);
      res?.modules?.map((item) => {
        let obj = {};
        obj.name = item.name;
        obj.permissions = item.permissions;
        setSepertion(obj);
      });
      // setRoleList(res?.modules);
    }
    console.log(res);
  };

  // const roleView = async (id) => {
  //     const res = await apiRequest(viewRole, id);
  //     if (res?.status == "success") {
  //         setName(res?.role_data?.name);
  //         setSelectedPermissions(res?.role_data?.permissions);
  //     }
  //     console.log(res);
  // };
  // const roleView = async (id) => {
  //   const res = await apiRequest(viewRole, id);
  //   if (res?.status == "success") {
  //     setName(res?.role_data?.name);
  //     setSelectedPermissions(res?.role_data?.permissions);
  //     let temp = [];
  //     res?.role?.permissions?.map((item, ind) => {
  //       temp.push(item?.id);
  //     });
  //     setPermissions(temp);

  //     let permissions_ = [...res?.role_data?.permissions];
  //     let parent_id = [];
  //     res?.modules?.map((item, ind) => {
  //       let finder = item?.permissions?.filter((i) =>
  //         permissions_?.includes(i?.id),
  //       );
  //       if (item?.permissions?.length == finder?.length) {
  //         parent_id.push(item?.id);
  //       }
  //     });
  //     setSelectedPermission_(parent_id);
  //   }
  //   // console.log(res);
  // };

  const roleView = async (id) => {
    const res = await apiRequest(viewRole, id);
    if (res?.status == "success") {
      setName(res?.role_data?.name);
      setSelectedPermissions(res?.role_data?.permissions);
    }
  };

  const selectRoles = () => {
    let ids = [];
    let ids_ = [];
    roleList?.map((item) => {
      ids_.push(item.id);
      item?.permissions?.map((d) => {
        ids.push(d.id);
      });
    });
    if (selectedPermissions.length < ids.length) {
      setSelectedPermissions(ids);
      setSelectedPermission_(ids_);
    } else {
      setSelectedPermissions([]);
      setSelectedPermission_([]);
    }
  };
  const specificRoles = (item) => {
    let ids = [...selectedPermissions];
    let temp = [...selectedPermission_];

    let per_ = [];
    item?.permissions?.map((item) => {
      per_.push(item?.id);
    });

    if (selectedPermission_?.includes(item?.id)) {
      let idx = temp?.indexOf(item?.id);
      temp.splice(idx, 1);
      let newArray = ids.filter((item) => !per_.includes(item));
      ids = newArray;
    } else {
      temp.push(item?.id);
      item?.permissions?.map((item) => {
        ids.push(item?.id);
      });
    }
    setSelectedPermission_(temp);
    setSelectedPermissions(ids);
  };

  const Add = async () => {
    if (!name) {
      setError(true);
      toast.error("Role Name cannot be empty");

      return;
    }
    if (selectedPermissions?.length == 0) {
      setError(true);
      return;
    }
    setError(false);
    const formdata = new FormData();
    formdata.append("name", name);
    selectedPermissions?.map((item, index) => {
      formdata.append(`permissions[${index}]`, item);
    });
    if (type == "edit") {
      formdata.append("role_id", id);
    }
    setLoader(true);
    const res = await apiRequest(
      type == "edit" ? updateRole : addRole,
      formdata,
    );
    setLoader(false);
    if (res?.status == "success") {
      toast.success(res?.message);
      navigate("/company-role");
    }
  };

  useEffect(() => {
    getPermissionsList();
    if (id) {
      roleView(id);
    }
  }, []);

  // console.log(selectedPermissions);

  // Handle toggling of permissions
  // const handlePermissionToggle = (roleId) => {
  //     let selectedlist = [];
  //     selectedPermissions.map((item) => {
  //         if (item != roleId) {
  //             selectedlist.push(item);
  //         }
  //     });
  //     if (!selectedPermissions?.includes(roleId)) {
  //         selectedlist.push(roleId);
  //     }
  //     setSelectedPermissions(selectedlist);
  // };
  const handlePermissionToggle = (roleId, parent_id, per_name) => {
    let selectedlist = [];
    let temp = [...selectedPermission_];
    let finder = roleList?.find((i) => i?.id == parent_id);
    let permissions_ = finder?.permissions;
    let permissions_id = finder?.permissions?.map((item) => item?.id);

    selectedPermissions.map((item) => {
      if (item != roleId) {
        selectedlist.push(item);
      }
    });
    if (!selectedPermissions?.includes(roleId)) {
      selectedlist.push(roleId);
    }

    // without list finder and add list id
    let per_name_split = per_name?.split("-");
    if (permissionArr?.includes(per_name_split?.[0])) {
      let listStartWith = permissions_?.find((item) =>
        item?.name?.startsWith("list"),
      );
      if (!selectedlist?.includes(listStartWith?.id)) {
        selectedlist.push(listStartWith?.id);
      }
    }

    // with list finder and remove all persmissom
    if (per_name?.startsWith("list")) {
      if (!selectedlist?.includes(roleId)) {
        let final = selectedlist?.filter(
          (item) => !permissions_id?.includes(item),
        );
        selectedlist = final;
      }
    }

    setSelectedPermissions(selectedlist);

    let matcher = permissions_id?.filter((i) => selectedlist?.includes(i));
    if (permissions_?.length == matcher?.length) {
      temp.push(parent_id);
    } else {
      let inx = temp?.indexOf(parent_id);
      if (inx >= 0) {
        temp.splice(inx, 1);
      }
    }
    setSelectedPermission_(temp);
  };

  useEffect(() => {
    if (roleList?.length === 0 || selectedPermissions?.length === 0) return;

    let parent_id = [];
    roleList?.forEach((item) => {
      if (!item?.permissions?.length) return;

      const allChildIds = item.permissions.map((p) => p.id);
      const matched = allChildIds.filter((pid) =>
        selectedPermissions.includes(pid),
      );

      if (matched.length > 0 && matched.length === allChildIds.length) {
        parent_id.push(item.id);
      }
    });

    setSelectedPermission_(parent_id);
  }, [roleList, selectedPermissions]);

  return (
    <div className="dashRightView home_section">
      <h2 className="f3 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22 primary ">
        {type == "edit" ? "Edit Role" : "Add Role"}
      </h2>
      <div className="input-pop p-3 mt-4">
        <div className="d-flex ac-jb">
          <div className="">
            <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18  ">
              Role Name<span className="text-danger">*</span>
            </h4>
            <input
              type="text"
              className="input-pop ps-2 w-100"
              placeholder=""
              onChange={(e) => {
                setName(e.target.value);
              }}
              disabled={type == "view" ? true : false}
              value={name}
            />
            {error && !name && <p className="err">Enter Role Name</p>}
          </div>
          {type != "view" && (
            <div className="">
              <button
                onClick={() => {
                  selectRoles();
                }}
                className="login-btn f2 fs-sm-10 fs-md-10 fs-lg-10 fs-xl-16 fs-xxl-18  white"
              >
                Select All
              </button>
            </div>
          )}
        </div>
        <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 ">
          Permission{" "}
          <span className="text-danger">
            (Atleast one permission is Required)*
          </span>
        </h4>
        {error && selectedPermissions?.length == 0 && (
          <p className="err">Select Permissions</p>
        )}
        <div className="d-flex flex-wrap mt-3 gap-2">
          {roleList?.map((item, id) => {
            return (
              <div className="w-24 mt-3 role-box">
                <div className="d-flex ac-jb mb-3">
                  <p className="f3 fs-xs-10 trans fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18">
                    {item?.name}
                  </p>
                  {type != "view" && (
                    <img
                      src={
                        selectedPermission_?.includes(item?.id)
                          ? toggle_on
                          : toggle_off
                      }
                      className="roles-icon pointer"
                      alt=""
                      onClick={() => {
                        specificRoles(item);
                      }}
                    />
                  )}
                </div>

                <div className="d-flex ac-js">
                  <div>
                    {item?.permissions?.map((permission, index) => {
                      const isSelected = selectedPermissions?.includes(
                        permission.id,
                      );
                      return (
                        <div className="d-flex ac-js gap-2 mb-2">
                          <img
                            src={isSelected ? toggle_on : toggle_off}
                            className={`roles-icon ${type !== "view" ? "pointer" : ""}`}
                            alt=""
                            onClick={() => {
                              if (type != "view") {
                                handlePermissionToggle(
                                  permission.id,
                                  item?.id,
                                  permission?.name,
                                );
                              }
                            }}
                          />
                          <p className=" f1 fs-xs-10 trans fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16 mb-0 ">
                            {permission?.name}
                          </p>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
        {type != "view" && (
          <button
            onClick={() => {
              Add();
            }}
            className="login-btn f2 fs-sm-10 fs-md-10 fs-lg-10 fs-xl-12 fs-xxl-14 mt-3 "
          >
            {loader && (
              <div
                class="spinner-border spinner-border-sm "
                role="status"
                style={{ marginRight: "5px" }}
              />
            )}
            Submit
          </button>
        )}
      </div>
    </div>
  );
};

export default CompanyRoleAdd;
